export default __webpack_public_path__ + "static/media/choose-the-right-paver-color-stairs.ed933b9d.jpg";